import Vue from 'vue'
import App from './App.vue'
import router from './router'


/* Inizio ElementUI */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import locale from 'element-ui/lib/locale/lang/en'
Vue.use(ElementUI, { locale })
/* Fine ElementUI */
        

/* Inizio TerAs */
import VueMoment from './teras/vue-moment'
Vue.use(VueMoment,'en')
import teras from './teras'
Vue.use(teras)
import axios from './teras/axios'
Vue.use(axios)


import VueAnalytics from 'vue-analytics'
const googleAnalyticsId = 'UA-2826949-19'
Vue.use(VueAnalytics, { id: googleAnalyticsId, router: router })


import './css/big.css'
/* Fine TerAs */
        
Vue.config.productionTip = false

/* Inizio TerAs-event */
teras.event.on('routerFirst', function(to) {
  axios.query('fetchAll',`SELECT * FROM programma WHERE evento=1151 ORDER BY parent,giorno,inizio`,{},teras,'_programma') 
  axios.query('fetchAll',`SELECT po.id AS id,po.programma, os.id AS ospite, LCASE(os.cognome) AS cognome, LCASE(os.nome) AS nome, os.email, os.nazione,  po.ruolo 
  FROM programmaospite AS po 
  LEFT JOIN iscrizioneospite AS io ON io.id=po.ospite
  LEFT JOIN contatto AS os ON os.id=io.contatto WHERE po.evento=1151 ORDER BY po.programma,po.ruolo,os.cognome,os.nome`,{},teras,'_programmaospite') .then((response) =>  {
    teras.app.step++
  })


  teras.app.routeInitial = to.path
})
teras.event.on('appReady', function() {
console.log("appReady appReady appReady appReady appReady appReady appReady")
router.push(teras.app.routeInitial)
})
teras.event.on('appExit', function() {
})
/* Fine TerAs-event */
        

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
